// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__16AjP","icon":"SortAdornment_icon__15jtG","up":"SortAdornment_up__1HvU3","down":"SortAdornment_down__tO6Bu","active":"SortAdornment_active__1lP4p"};